
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {
      ApplicationActions,
      ApplicationViewModel,
      IdentityValueViewModel,
      MedicalCertificateListItem,
      MedicalCertificateRequirementViewModel,
      RequirementFulfillmentViewModel,
      RequirementsClient,
      ValidityStatus
    } from "@/api-client";
    import {BvTableFieldArray} from "bootstrap-vue"
    import RequirementsTable from "@/features/applications/components/RequirementsTable.vue";
    import TableItem from "@/features/applications/components/TableItem";
    import Loader from "@/features/shared/components/Loader";
    import {ls} from "@/CultureService";
    import {formatDate} from "@/formatting/dateFormatter";
    import ValidityStatusBadge from "@/features/shared/components/ValidityStatusBadge.vue";

    class MedicalCertificateTableItem implements TableItem {
        constructor(medicalCertificate: MedicalCertificateListItem) {
            this.id = medicalCertificate.id;
            this.medicalInstitutionName = medicalCertificate.medicalInstitutionName;
            this.medicalPractitionerFullName = medicalCertificate.medicalPractitionerFullName;
            this.positionName = medicalCertificate.positionName;
            this.validUntil = medicalCertificate.validUntil;
            this.issuedAt = medicalCertificate.issuedAt;
            this.status = medicalCertificate.status;
        }

        id: string;
        medicalInstitutionName: string;
        medicalPractitionerFullName: string;
        positionName: string;
        issuedAt: Date;
        validUntil: Date;
        status: ValidityStatus;
    }

    @Component({
        components: {
            RequirementsTable,
            ValidityStatusBadge
        }
    })
    export default class MedicalCertificateRequirement extends Vue {
        public static requirementDescriptionTitle = ls.Applications_Requirements_MedicalCertificate_Title_MedicalCertificateRequirements;
        public static headingDescription = ls.Applications_Requirements_MedicalCertificate_Heading_AddingMedicalCertificate;

        @Prop({required: true})
        application!: ApplicationViewModel; // TODO: Constrain this.
        @Prop({required: true})
        requirementFulfillment!: RequirementFulfillmentViewModel;
        @Prop({required: true})
        requirement!: MedicalCertificateRequirementViewModel;
        @Prop({required: true})
        requirementValue!: IdentityValueViewModel | null;
        @Prop({required: true})
        actions!: ApplicationActions;

        chosen: MedicalCertificateListItem | null = null;
        choosable: MedicalCertificateListItem[] = [];

        chosenLoader = new Loader();
        choosableLoader = new Loader();

        fields: BvTableFieldArray = [
            {
                key: 'medicalInstitutionName',
                label: this.$ls.Applications_Requirements_MedicalCertificate_Table_Label_MedicalInstitution,
                sortable: false,
                thClass: "w-25"
            },
            {
                key: 'medicalPractitionerFullName',
                label: this.$ls.Applications_Requirements_MedicalCertificate_Table_Label_MedicalPractitioner,
                sortable: false,
                thClass: "w-15"
            },
            {
                key: 'positionName',
                label: this.$ls.Applications_Requirements_MedicalCertificate_Table_Label_Position,
                sortable: false,
                thClass: "w-15"
            },
            {
                key: 'issuedAt',
                label: this.$ls.Global_Label_IssueDateShort,
                sortable: false,
                thClass: "w-10",
                formatter: (dateString : string) => formatDate(dateString)
            },
            {
                key: 'validUntil',
                label: this.$ls.Global_Label_ValidUntil,
                sortable: false,
                thClass: "w-10",
                formatter: (dateString : string) => formatDate(dateString)
            },
            { 
                key: 'status', 
                label: this.$ls.Global_Label_DocumentState, 
                sortable: false, 
                sortByFormatted: false, 
                thClass: 'w-10'
            },
            {
                key: 'actions',
                label: '',
                sortable: false,
                tdClass: 'table-actions'
            }
        ];

        async created() {
            if (this.requirementValue) {
                new RequirementsClient()
                    .setLoader(this.chosenLoader)
                    .chosenMedicalCertificate(this.application.id, this.requirement.id)
                    .then(result => this.chosen = result);
            }

            if (this.actions.canFillRequirements) {
                await new RequirementsClient()
                    .setLoader(this.choosableLoader)
                    .choosable(this.application.id, this.requirement.id)
                    .then(result => this.choosable = result);
            }
        }

        async choose(tableItem: TableItem) {
            new RequirementsClient().chooseMedicalCertificate(tableItem.id, this.application.id, this.requirement.id).then(
                () => this.$emit("application-changed"),
                error => this.$emit("error-happened", error));
        }

        async removeChosen() {
            new RequirementsClient().removeChosenValue(this.application.id, this.requirement.id).then(
                () => this.$emit("application-changed"),
                error => this.$emit("error-happened", error));
        }

        get chosenTableItems() : TableItem[] {
            if (!this.chosen)
                return [];
            return [ new MedicalCertificateTableItem(this.chosen) ];
        }

        get choosableTableItems(): TableItem[] | null {
            if (!this.choosable) {
                return null;
            }
            return this.choosable.map(x => new MedicalCertificateTableItem(x))
        }
      
        viewDetails(medicalCertificate: MedicalCertificateTableItem){
          this.$router.push({name: 'requirement-medical-certificate-details', params:{id: medicalCertificate.id}})
        }
    }
